(function () {
  'use strict';

  function initScrollReveal() {
    if (!document.body.classList.contains('template-index')) return;

    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    sections.forEach(function (el) {
      el.classList.add('fb-animate-in');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAOS() {
    if (typeof AOS === 'undefined') return;
    AOS.init({
      once: true,
      duration: 700,
      easing: 'ease-out-cubic',
      offset: 60,
      disable: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'all' : false
    });
  }

  function initWhatsAppLabel() {
    var btn = document.querySelector('.fb-whatsapp-btn');
    if (btn && btn.querySelector('.fb-whatsapp-btn__label')) {
      btn.classList.add('has-label');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initAOS();
    initWhatsAppLabel();
  });
})();
